<template>
  <div class="question-wrapper" :id="id">
    <p class="text-subtitle1 question-title">
      <span class="label">{{number}}</span>
      <span>{{title}}</span>
    </p>
    <div class="q-pa-sm text-white">
      <div class="q-gutter-sm" v-for="(item,index) in options" :key="item.name">
        <q-checkbox v-model="values[index]" :disable="disable[index]" dark :label="item.name"/>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      values: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      disable: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
    }
  },
  props: {
    number: {
      type: [Number, String],
      default: () => null
    },
    value: {
      type: String,
      default: () => ''
    },
    id: {
      type: String,
      default: () => ''
    },
    title: {
      type: String,
      default: () => ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
  },
  created() {
    // this.values = arr
  },
  mounted() {
  },
  watch: {
    values: {
      handler(val) {
        let num = 0
        const selected = []

        for (let i = 0; i < val.length; i++) {
          const element = val[i]
          if (element) {
            num += 1
            if (num < 4) {
              selected.push(i)
            } else {
              break
            }
          }
        }

        if (selected.length === 3) {
          this.disable.forEach((element, index) => {
            if (!selected.includes(index)) {
              this.disable[index] = true
            }
          })

          const data = {
            selected,
            id: this.id
          }

          this.$emit('handleChange', data)
        } else if (selected.length < 3) {
          this.disable.forEach((element, index) => {
            this.disable[index] = false
          })
          this.$emit('handleChange',
            {
              selected: [],
              id: this.id
            }
          )
        }
      }
    },
  }
}
</script>

<style lang="scss">
</style>
